module.exports = __webpack_public_path__ + "img/016c8d8d47e334382156ee8c6ae14d1f.png";